import { render, staticRenderFns } from "./VaccineCheckinScanPage.vue?vue&type=template&id=538e3fd3&"
import script from "./VaccineCheckinScanPage.vue?vue&type=script&lang=js&"
export * from "./VaccineCheckinScanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('538e3fd3')) {
      api.createRecord('538e3fd3', component.options)
    } else {
      api.reload('538e3fd3', component.options)
    }
    module.hot.accept("./VaccineCheckinScanPage.vue?vue&type=template&id=538e3fd3&", function () {
      api.rerender('538e3fd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VaccineViews/VaccineCheckinScanPage/VaccineCheckinScanPage.vue"
export default component.exports